import {FunctionComponent, useEffect} from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { UserDetailActions } from "./model";

export const LandingComponent: FunctionComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    value: { data: userDetails },
  } = useSelector((rootState: RootState) => rootState.userDetail.userDetail);

  useEffect(() => {
    dispatch(UserDetailActions.getUserDetail());
}, [dispatch]);

  useEffect(() => {
    if (userDetails?.id) {
      history.push(`/users/view/${userDetails.id}`);
    }
  }, [userDetails?.id]);

  return (
    <div></div>
  );
};

